import i18n from 'i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import {initReactI18next} from 'react-i18next';
import languageGB from './config/en-gb/translate.json';
import gbConfig from './config/en-gb/config.json';
import languageZA from './config/en-za/translate.json';
import zaConfig from './config/en-za/config.json';
import languageDE from './config/de-de/translate.json';
import deConfig from './config/de-de/config.json';
import languageIT from './config/it-it/translate.json';
import itConfig from './config/it-it/config.json';
import languageES from './config/es-es/translate.json';
import esConfig from './config/es-es/config.json';
import languageCAEN from './config/en-ca/translate.json';
import caenConfig from './config/en-ca/config.json';
import languageCAFR from './config/fr-ca/translate.json';
import cafrConfig from './config/fr-ca/config.json';
import languageUS from './config/en-us/translate.json';
import usConfig from './config/en-us/config.json';
import languageFR from './config/fr-fr/translate.json';
import frConfig from './config/fr-fr/config.json';
import languageAT from './config/de-at/translate.json';
import atConfig from './config/de-at/config.json';
import languageBR from './config/pt-br/translate.json';
import brConfig from './config/pt-br/config.json';
import languageJP from './config/ja-jp/translate.json';
import jpConfig from './config/ja-jp/config.json';
import languageRU from './config/ru-ru/translate.json';
import ruConfig from './config/ru-ru/config.json';
import languagePH from './config/en-ph/translate.json';
import phConfig from './config/en-ph/config.json';
import languageIN from './config/en-in/translate.json';
import inConfig from './config/en-in/config.json';
import languageAU from './config/en-au/translate.json';
import auConfig from './config/en-au/config.json';
import languageNZ from './config/en-nz/translate.json';
import nzConfig from './config/en-nz/config.json';
import languageHU from './config/hu-hu/translate.json';
import huConfig from './config/hu-hu/config.json';
import languageRO from './config/ro-ro/translate.json';
import roConfig from './config/ro-ro/config.json';
import languagePL from './config/pl-pl/translate.json';
import plConfig from './config/pl-pl/config.json';
import languageGNE from './config/gne/translate.json';
import gneConfig from './config/gne/config.json';
import languageGlobal from './config/global/translate.json';
import globalConfig from './config/global/config.json';
import languageCZSK from './config/czsk/translate.json';
import czskConfig from './config/czsk/config.json';
import languageMY from './config/en-my/translate.json';
import myConfig from './config/en-my/config.json';
import languageSA from './config/en-sa/translate.json';
import saConfig from './config/en-sa/config.json';
import languageCO from './config/es-co/translate.json';
import coConfig from './config/es-co/config.json';
import languageNL from './config/nl-nl/translate.json';
import nlConfig from './config/nl-nl/config.json';
import languageBEFR from './config/fr-be/translate.json';
import befrConfig from './config/fr-be/config.json';
import languageBENL from './config/nl-be/translate.json';
import benlConfig from './config/nl-be/config.json';
import languagePK from './config/en-pk/translate.json';
import pkConfig from './config/en-pk/config.json';
import languageMX from './config/es-mx/translate.json';
import mxConfig from './config/es-mx/config.json';
import languageEWA from './config/ewa/translate.json';
import ewaConfig from './config/ewa/config.json';
import languageHK from './config/en-hk/translate.json';
import hkConfig from './config/en-hk/config.json';
import languageKR from './config/ko-kr/translate.json';
import krConfig from './config/ko-kr/config.json';
import languageEG from './config/en-eg/translate.json';
import egConfig from './config/en-eg/config.json';
import languageSE from './config/sv-se/translate.json';
import seConfig from './config/sv-se/config.json';
import languageGR from './config/el-gr/translate.json';
import grConfig from './config/el-gr/config.json';
import languageMA from './config/fr-ma/translate.json';
import maConfig from './config/fr-ma/config.json';
import languageFWA from './config/fwa/translate.json';
import fwaConfig from './config/fwa/config.json';
import languageARCL from './config/arcl/translate.json';
import arclConfig from './config/arcl/config.json';
import languageRS from './config/sr-rs/translate.json';
import rsConfig from './config/sr-rs/config.json';
import languageNO from './config/en-no/translate.json';
import noConfig from './config/en-no/config.json';
import languageTH from './config/en-th/translate.json';
import thConfig from './config/en-th/config.json';
import languageBG from './config/bg-bg/translate.json';
import bgConfig from './config/bg-bg/config.json';
import languageUA from './config/uk-ua/translate.json';
import uaConfig from './config/uk-ua/config.json';
import languageTW from './config/zh-tw/translate.json';
import twConfig from './config/zh-tw/config.json';
import languageIE from './config/en-ie/translate.json';
import ieConfig from './config/en-ie/config.json';
import languageID from './config/id-id/translate.json';
import idConfig from './config/id-id/config.json';
import languageIL from './config/en-il/translate.json';
import ilConfig from './config/en-il/config.json';

const resources = {
    en_gb: {
        translation: languageGB,
        configuration: gbConfig
    },
    en_za: {
        translation: languageZA,
        configuration: zaConfig
    },
    de_de: {
        translation: languageDE,
        configuration: deConfig
    },
    it_it: {
        translation: languageIT,
        configuration: itConfig
    },
    es_es: {
        translation: languageES,
        configuration: esConfig
    },
    en_ca: {
        translation: languageCAEN,
        configuration: caenConfig
    },
    fr_ca: {
        translation: languageCAFR,
        configuration: cafrConfig
    },
    en_us: {
        translation: languageUS,
        configuration: usConfig
    },
    de_at: {
        translation: languageAT,
        configuration: atConfig
    },
    fr_fr: {
        translation: languageFR,
        configuration: frConfig
    },
    pt_br: {
        translation: languageBR,
        configuration: brConfig
    },
    ja_jp: {
        translation: languageJP,
        configuration: jpConfig
    },
    ru_ru: {
        translation: languageRU,
        configuration: ruConfig
    },
    en_ph: {
        translation: languagePH,
        configuration: phConfig
    },
    en_in: {
        translation: languageIN,
        configuration: inConfig
    },
    en_au: {
        translation: languageAU,
        configuration: auConfig
    },
    en_nz: {
        translation: languageNZ,
        configuration: nzConfig
    },
    hu_hu: {
        translation: languageHU,
        configuration: huConfig
    },
    ro_ro: {
        translation: languageRO,
        configuration: roConfig
    },
    pl_pl: {
        translation: languagePL,
        configuration: plConfig
    },
    czsk: {
        translation: languageCZSK,
        configuration: czskConfig
    },
    gne: {
        translation: languageGNE,
        configuration: gneConfig
    },
    global: {
        translation: languageGlobal,
        configuration: globalConfig
    },
    en_my:{
        translation: languageMY,
        configuration: myConfig
    },
    en_sa: {
        translation: languageSA,
        configuration: saConfig
    },
    es_co: {
        translation: languageCO,
        configuration: coConfig
    },
    nl_nl: {
        translation: languageNL,
        configuration: nlConfig
    },
    fr_be: {
        translation: languageBEFR,
        configuration: befrConfig
    },
    nl_be: {
        translation: languageBENL,
        configuration: benlConfig
    },
    en_pk: {
        translation: languagePK,
        configuration: pkConfig
    },
    es_mx: {
        translation: languageMX,
        configuration: mxConfig
    },
     ewa: {
        translation: languageEWA,
        configuration: ewaConfig
    },
     en_hk: {
        translation: languageHK,
        configuration: hkConfig
    },
     ko_kr: {
        translation: languageKR,
        configuration: krConfig
    },
    en_eg: {
        translation: languageEG,
        configuration: egConfig
    },
    sv_se: {
        translation: languageSE,
        configuration: seConfig
    },
    el_gr: {
        translation: languageGR,
        configuration: grConfig
    },
    fr_ma: {
        translation: languageMA,
        configuration: maConfig
    },
    fwa: {
        translation: languageFWA,
        configuration: fwaConfig
    },
    arcl: {
        translation: languageARCL,
        configuration: arclConfig
    },
    sr_rs: {
        translation: languageRS,
        configuration: rsConfig
    },
    en_no: {
        translation: languageNO,
        configuration: noConfig
    },
    en_th: {
        translation: languageTH,
        configuration: thConfig
    },
    bg_bg: {
        translation: languageBG,
        configuration: bgConfig
    },
    uk_ua: {
        translation: languageUA,
        configuration: uaConfig
    },
    zh_tw: {
        translation: languageTW,
        configuration: twConfig
    },
    en_ie: {
        translation: languageIE,
        configuration: ieConfig
    },
     id_id: {
        translation: languageID,
        configuration: idConfig
    },
      en_il: {
        translation: languageIL,
        configuration: ilConfig
    }
};

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
    resources,
    /* default language when load the website in browser */
    lng: globalConfig.SET_DEFAULT_MARKET,
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: globalConfig.SET_DEFAULT_MARKET,
    /* debugger For Development environment */
    debug: true,
    ns: ["translation", "configuration"],
    defaultNS: "translation",
    keySeparator: "#",
    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    },
    react: {
        useSuspense: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    }
})

export default i18n;